import { useEffect, useMemo, useState } from "react";

import MUIDataTable from "mui-datatables";

import {
	AvatarGroup,
	Box,
	Button,
	Grid,
	Popover,
	Switch,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";

import { RemoveRedEye, Restore } from "@mui/icons-material";
import { Avatar } from "@mui/material";
import { debounce } from "lodash";
import moment from "moment";

import { getAll, update } from "../../../apis/SearchQueries";
import { FilterAutocomplete } from "../../../components/Form/FilterAutocomplete";
import { getAllUsers } from "../../../apis/user";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { FormControl } from "@mui/material";
import { InputLabel } from "@mui/material";
import { Toolbar } from "@mui/material";
import { Typography } from "@mui/material";
import { CardContent } from "@mui/material";
import { Stack } from "@mui/material";

export default function QueriesPage() {
	const [data, setData] = useState([]);
	const [page, setPage] = useState(0);
	const [reset, setReset] = useState(false);
	const [, setLoading] = useState(false);
	const [rowsCount, setRowsCount] = useState(10);

	const [count, setCount] = useState(0);

	const [filters, setFilters] = useState({});
	const handleChange = useMemo(
		() => debounce((name, item) => {
			console.log(typeof item, name);

			if (item) {
				setFilters((prev) => ({ ...prev, [name]: item?.id }));
			}
		}, 500),
		[],
	);

	const handleReset = () => {
		setFilters({});
		setReset(true);
		setPage(0);
	};
	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				const cleanObj = Object.fromEntries(
					Object.entries(filters).filter(
						([_, value]) =>
							value !== "" && value !== null && value !== undefined,
					),
				);
				const response = await getAll({
					page_size: rowsCount,
					page: page + 1,
					...cleanObj,
				});

				setData(response.results);
				setCount(response.count);
			} catch (error) {
				console.log(error);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [page, filters, rowsCount]);

	const columns = [
		{
			name: "id",
			label: "Id",
			options: {
				filter: false,
			},
		},

		{
			name: "query",
			label: "Query",
			options: {
				filter: false,
			},
		},
		{
			name: "user",
			label: "User",
			options: {
				filter: false,
				customBodyRender: (value) => value?.name || "-",
			},
		},

		{
			name: "intent",
			label: "Intent",
			options: {
				filter: false,
			},
		},

		{
			name: "results",
			label: "Results",
			options: {
				filter: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<AvatarGroup
							spacing="medium"
							componentsProps={{
								additionalAvatar: {
									onClick: (e) => {
										console.log("yes");
										handlePopoverOpen(e, value);
									},
									sx: {
										cursor: "pointer",
										bgcolor: "primary.main",
									},
									title: "See all Results", // optional tooltip
								},
							}}
						>
							{value.map((item, i) => (
								<Avatar
									key={"gallery-" + i}
									alt="List Logo"
									// variant="square"
									sx={{
										// width: 50,
										// height: 67,
										objectFit: "fill",

										// margin: 5,
										// borderRadius: 1,
									}}
									src={item?.image.file}
								/>
							))}
						</AvatarGroup>
					);
				},
			},
		},
		{
			name: "trending",
			label: "Trending",
			options: {
				filter: false,
				customBodyRender: (value, tableMeta) => {
					return (
						<Switch
							checked={value}
							onChange={async (e) => {
								const checked = e.target.checked;

								setData((prev) =>
									prev.map((row, index) =>
										index === tableMeta.rowIndex
											? { ...row, trending: checked }
											: row,
									),
								);

								try {
									await update(data[tableMeta.rowIndex].id, {
										trending: checked,
									});
								} catch (err) {
									// revert if needed
								}
							}}
							inputProps={{
								"aria-label": "controlled",
							}}
						/>
					);
				},
			},
		},
		{
			name: "allow_autosuggest",
			label: "Allow Autosuggest",
			options: {
				filter: false,
				customBodyRender: (value, tableMeta) => {
					return (
						<Switch
							checked={value}
							onChange={async (e) => {
								const checked = e.target.checked;

								setData((prev) =>
									prev.map((row, index) =>
										index === tableMeta.rowIndex
											? {
												...row,
												allow_autosuggest: checked,
											}
											: row,
									),
								);

								try {
									await update(data[tableMeta.rowIndex].id, {
										allow_autosuggest: checked,
									});
								} catch (err) {
									// revert if needed
								}
							}}
							inputProps={{
								"aria-label": "controlled",
							}}
						/>
					);
				},
			},
		},

		{
			name: "updated_at",
			label: "Updated At",

			options: {
				filter: false,
				customBodyRender: (value) =>
					moment(value).format("DD-MM-YY hh:mm A"),
			},
		},

		{
			name: "",
			label: "Action",
			options: {
				display: true,
				filter: false,

				sort: false,

				customBodyRender: (value) => (
					<IconButton color="primary">
						<RemoveRedEye />
					</IconButton>
				),
			},
		},
	];

	const handleSearchChange = useMemo(
		() => debounce((searchText) => {
			setFilters((pre) => ({ ...pre, query: searchText }));
		}, 500),
		[],
	);

	const options = {
		selectableRows: "none",
		responsive: "standard",
		// elevation: 0,
		download: false,
		print: false,
		viewColumns: false,
		filter: false,
		search: true,
		sort: false,
		serverSide: true,
		count: count,
		page: page,

		rowsPerPage: rowsCount,
		rowsPerPageOptions: [10, 25, 50],
		onChangePage(currentPage) {
			setPage(currentPage);
		},
		onSearchChange: handleSearchChange,
		onChangeRowsPerPage(numberOfRows) {
			setRowsCount(numberOfRows);
			if (page !== 0) {
				setPage(0);
			}
		},
	};
	const [anchorEl, setAnchorEl] = useState(null);

	const [selectedResults, setSelectedResults] = useState([]);

	const handlePopoverOpen = (event, results) => {
		setAnchorEl(event.currentTarget);
		setSelectedResults(results);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setSelectedResults([]);
	};
	const open = Boolean(anchorEl);

	return (
		<Grid container justifyContent={"center"}>
			<Grid item md={10}>
				<Box sx={{ p: 5 }}>
					<Toolbar sx={{ px: 0 }}>
						<Typography
							// className={classes.title}
							variant="h4"
							noWrap
						>
							Queries
						</Typography>
					</Toolbar>
					<Grid
						container
						spacing={2}
						pb={2}
						alignItems={"center"}
						justifyContent={"flex-end"}
					>
						<Grid item xs={12} sm={3}>
							<FilterAutocomplete
								fetchOptions={getAllUsers}
								label={"User"}
								handleChange={handleChange}
								name={"user"}
								reset={reset}
								setReset={setReset}
							/>
						</Grid>
						<Grid item xs={12} sm={3}>
							<FormControl fullWidth>
								<InputLabel>Intent</InputLabel>
								<Select
									value={filters.intent ?? ""}
									label="Allow Autosuggest"
									onChange={(event) =>
										handleChange("intent", {
											id: event.target.value,
										})
									}
									variant="outlined"
								>
									<MenuItem value="">All</MenuItem>
									<MenuItem value="product">
										Products
									</MenuItem>
									<MenuItem value="outfit">Outfits</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={3}>
							<FormControl fullWidth>
								<InputLabel>Allow Autosuggest</InputLabel>
								<Select
									value={filters.allow_autosuggest ?? ""}
									label="Allow Autosuggest"
									onChange={(event) =>
										handleChange("allow_autosuggest", {
											id: event.target.value,
										})
									}
									variant="outlined"
								>
									<MenuItem value="">All</MenuItem>
									<MenuItem value="True">Show</MenuItem>
									<MenuItem value="False">Hide</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={3}>
							<FormControl fullWidth>
								<InputLabel>Trending</InputLabel>
								<Select
									labelId="demo-select-small"
									id="demo-select-small"
									value={filters.trending ?? ""}
									label="Trending"
									onChange={(event) =>
										handleChange("trending", {
											id: event.target.value,
										})
									}
									fullWidth
									variant="outlined"
								>
									<MenuItem value="">All</MenuItem>
									<MenuItem value="True">Yes</MenuItem>
									<MenuItem value="False">No</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item>
							<Button
								variant="contained"
								onClick={handleReset}
								startIcon={<Restore />}
							>
								Reset
							</Button>
						</Grid>
					</Grid>
					<MUIDataTable
						title={"Queries"}
						data={data}
						columns={columns}
						options={options}
					/>
				</Box>
			</Grid>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<CardContent>
					<Typography paragraph>Results:</Typography>
					<Box>
						{selectedResults?.map((product, i) => {
							return (
								<Stack
									key={`playoff-group-${i}`}
									direction="row"
									alignItems="center"
									gap={1}
								>
									<Avatar
										alt={
											product.name
												? product.name
												: product.title
													? product.title
													: ""
										}
										src={product?.image?.file}
									/>
									<Typography
										paragraph
										sx={{
											marginBottom: 0,
										}}
									>
										{product.name
											? product.name
											: product.title
												? product.title
												: ""}
									</Typography>
								</Stack>
							);
						})}
					</Box>
				</CardContent>
			</Popover>
		</Grid>
	);
}
